/**
 * FAQ accordion — height animation on every open/close.
 * Native <details> can't animate reliably with grid-template-rows alone.
 */
(function () {
  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var PROP = 'height';
  var TRANSITION = 'height 0.5s cubic-bezier(0.4, 0, 0.2, 1)';

  function panelOf(details) {
    return details.querySelector('.ll-faqs__panel');
  }

  function clearInline(panel) {
    panel.style.height = '';
    panel.style.overflow = '';
    panel.style.transition = '';
  }

  function lock(details, on) {
    details.dataset.llAnimating = on ? '1' : '';
  }

  function isLocked(details) {
    return details.dataset.llAnimating === '1';
  }

  function onHeightEnd(panel, done) {
    var handler = function (event) {
      if (event.target !== panel || event.propertyName !== PROP) return;
      panel.removeEventListener('transitionend', handler);
      done();
    };
    panel.addEventListener('transitionend', handler);
  }

  function animateOpen(details, panel) {
    details.open = true;
    if (REDUCED) return;

    lock(details, true);
    var inner = panel.querySelector('.ll-faqs__panel-inner') || panel;
    panel.style.transition = 'none';
    panel.style.overflow = 'hidden';
    panel.style.height = '0px';
    void panel.offsetHeight;

    var target = Math.ceil(inner.scrollHeight);
    panel.style.transition = TRANSITION;
    panel.style.height = target + 'px';

    onHeightEnd(panel, function () {
      clearInline(panel);
      lock(details, false);
    });
  }

  function animateClose(details, panel) {
    if (REDUCED) {
      details.open = false;
      return;
    }

    lock(details, true);
    var height = Math.ceil(panel.getBoundingClientRect().height);
    panel.style.transition = 'none';
    panel.style.overflow = 'hidden';
    panel.style.height = height + 'px';
    void panel.offsetHeight;

    panel.style.transition = TRANSITION;
    panel.style.height = '0px';

    onHeightEnd(panel, function () {
      details.open = false;
      clearInline(panel);
      lock(details, false);
    });
  }

  function onSummaryActivate(event) {
    var summary = event.target.closest('summary.ll-faqs__question');
    if (!summary) return;

    var details = summary.parentElement;
    if (!details || !details.classList.contains('ll-faqs__item')) return;

    var panel = panelOf(details);
    if (!panel) return;

    event.preventDefault();
    if (isLocked(details)) return;

    if (details.open) {
      animateClose(details, panel);
    } else {
      animateOpen(details, panel);
    }
  }

  function bind(root) {
    var list = root.querySelector('.ll-faqs__list');
    if (!list || list.dataset.llFaqsBound === '1') return;
    list.dataset.llFaqsBound = '1';
    list.addEventListener('click', onSummaryActivate);
  }

  function init() {
    document.querySelectorAll('.ll-faqs').forEach(bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (event.target) bind(event.target);
  });
})();
